export function fStringCapitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function fLowerCase(string) {
  return string.toLowerCase();
}
